'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

import { useLocale } from '@src/i18n/LocaleProvider'
import { cn } from '@src/utils/tailwind'

interface CarouselArrowsProps {
  desktopVisible: boolean
  overflowDesktop?: boolean
  arrowPositions: {
    vertical: string
    horizontal: string
  }
  arrowIconColor?: string
  arrowBackgroundColor?: string
  previousSlide: (args: any) => void
  nextSlide: (args: any) => void
}

export const CarouselArrows = ({
  desktopVisible,
  arrowPositions,
  arrowBackgroundColor,
  arrowIconColor,
  previousSlide,
  nextSlide,
}: CarouselArrowsProps) => {
  const { t } = useLocale('carousel')
  const commonStyles = [
    '[--arrow-size:40px] lg:[--arrow-offset-x:6px] xl:[--arrow-offset-x:12px]',
    'flex items-center justify-center bg-white absolute z-10 flex size-(--arrow-size) shrink-0 rounded-full shadow-[0px_1px_3px_0px_#16181940] transition-all hover:bg-bodi-gray-pearl',
  ]

  return (
    <div
      className={cn('hidden', {
        'lg:block': desktopVisible,
        'md:hidden lg:hidden': !desktopVisible,
      })}
    >
      <button
        onClick={previousSlide}
        aria-label={t('previous-slide')}
        className={cn(
          commonStyles,
          'visible absolute z-10 flex size-10 shrink-0 items-center rounded-full sm:visible',
          {
            visible: desktopVisible,
            hidden: !desktopVisible,
          }
        )}
        style={{
          backgroundColor: arrowBackgroundColor,
          top: arrowPositions.vertical,
          left: arrowPositions.horizontal,
        }}
      >
        <ChevronLeftIcon height={'30px'} width={'30px'} fill={arrowIconColor} />
      </button>
      <button
        onClick={nextSlide}
        aria-label={t('next-slide')}
        className={cn(
          commonStyles,
          'visible absolute z-10 flex size-10 shrink-0 items-center rounded-full sm:visible',
          {
            visible: desktopVisible,
            hidden: !desktopVisible,
          }
        )}
        style={{
          backgroundColor: arrowBackgroundColor,
          top: arrowPositions.vertical,
          right: arrowPositions.horizontal,
        }}
      >
        <ChevronRightIcon height={'30px'} width={'30px'} fill={arrowIconColor} />
      </button>
    </div>
  )
}
